export const COMMON_DATE_TIME_FORMAT = 'DD MMMM YYYY HH:mm:ss';

export const SERVICE_REQUEST_DATE_FORMAT = 'DD-MM-YYYY';

export const REQUEST_DETAILS_DATE_FORMAT = 'DD/MM/YYYY';
